import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressService } from '../../../../../providers/services/address.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { AppComponent } from '../../../../../app.component';
import { share, takeUntil} from 'rxjs/operators';
import { PlatformToastMessage, PlatformToastMessageType } from '@pdp/common';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pdp-add-address',
    templateUrl: './add-address.component.html',
    styleUrls: ['./add-address.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, NgIf, NgFor, MatButton]
})
export class AddAddressComponent implements OnInit, OnDestroy {

    // when order is updated directly at the checkout page, say address is added we want to reload that order and dispaly new data
    public static _orderUpdatedWithNewAddress: Subject<any> = new Subject();
    public static orderUpdateWithAddress;
    constructor(public addressService: AddressService,
                public formBuilder: UntypedFormBuilder,
                public router: Router,
                public activatedRoute: ActivatedRoute,
                public cdRef: ChangeDetectorRef) {
                    AddAddressComponent.orderUpdateWithAddress = AddAddressComponent._orderUpdatedWithNewAddress.asObservable().pipe(share());
                    this.buildForm();
                }



    public countries: string[] = ['Srbija', 'Crna gora', 'Hrvatska', 'Bosna i Hercegovina', 'Slovenija'];
    public cities: string[] = ['Beograd', 'Novi Sad', 'Niš'];
    public requestOrigin: any;
    public addAddressForm: UntypedFormGroup;

    public model: any;
    public loading = false;
    public submitted = false;
    private unsubscribe: Subject<void> = new Subject();

    public formErrors = {
        'address' : '',
        'primaryPhoneNumber' : '',
        'secondaryPhoneNumber': '',
        'countryName' : '',
        'city' : '',
        'postalCode' : ''
    };

   public validationMessages = {
        'countryName': {
          'required': 'Molimo odaberite državu',
        },
        'city' : {
          'required': 'Molimo upišite Grad'/*,
          'selectDropdownCheck': 'Molimo odaberite Grad'*/
        },
        'address': {
            'required': 'Unesite adresu',
            'minlength': 'Adresa mora da sadrži minumum 3 slova'
        },
        'postalCode' : {
            'required' : 'Molimo unesite Poštanski broj',
            'pattern' : 'Poštanski broj mora sadržati 5 cifara'
        },
        'primaryPhoneNumber': {
          'required': 'Molimo unesite broj telefona',
        },
        'secondaryPhoneNumber': {
        }
   };


    public addAddress(data) {
        this.model = this.addAddressForm.value;
        this.submitted = true;
        this.onValueChanged(this.model);
        if (this.addAddressForm.valid) {
            this.loading = true;
            // this is how we distinguish two scenarios.
            // 1. Add address from profile page ( address should not be added to an order automatically on the backend)
            // 2. Add address from select-shipping pre checkout page ( addres should be added to an order automatically on the backend)
            const addAddressToCurrentOrder = this.requestOrigin ? false : true;
            this.addressService.create(this.model , addAddressToCurrentOrder)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(res => {
                AppComponent.toastSubject.next(new PlatformToastMessage(PlatformToastMessageType.SUCCESS, $localize`:@@AdresaUspesnoKreirana:Adresa uspešno kreirana`));
                this.addAddressForm.reset(); // clears form values
                if (this.requestOrigin) {
                    // we triggered adding address from address-book
                    this.router.navigate(['/account/dashboard/address-book']);
                } else {
                    // if undefined we added address from checkout page
                    this.router.navigate(['/checkout/confirm']);
                    AddAddressComponent._orderUpdatedWithNewAddress.next('addressAddedToOrder');
                }
                    this.loading = false;
                    this.submitted = false;
            },
            error => {
                this.submitted = false;
                this.loading = false;
                AppComponent.toastSubject.next(new PlatformToastMessage(PlatformToastMessageType.ERROR, 'Došlo je do greške prilikom kreiranje adrese'));
            });
        }
    }

    ngOnInit() {
        this.activatedRoute.params
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(e => {
            this.requestOrigin = e['route'];
        });
    }

    public buildForm(): void {
            this.addAddressForm = this.formBuilder.group({

                address: new UntypedFormControl(null, [
                    Validators.required,
                    Validators.minLength(3)
                ]),
                postalCode: new UntypedFormControl(null, [
                     Validators.required,
                     Validators.pattern('^[0-9]{5}$')
                ]),
                primaryPhoneNumber: new UntypedFormControl(null, [
                     Validators.required
                    // Validators.pattern("[0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]")
                ]),
                secondaryPhoneNumber: new UntypedFormControl(null, [
                    // Validators.pattern("[0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]")
                ]),
                countryName: new UntypedFormControl(null, [
                    Validators.required
                ]),
                city: new UntypedFormControl(null, [
                     Validators.required/*, SelectDropdown0Validator.selectDropdownCheck*/
                ])
            });

            const control =  this.addAddressForm.patchValue({'countryName': 'Srbija'});

            // after each value change send data to this.onValueChanged
           this.addAddressForm.valueChanges
           .pipe(takeUntil(this.unsubscribe))
           .subscribe(data => this.onValueChanged(data));
    }

    /**
     * Performs validation of form after each input field value changes
     */
    public onValueChanged(data?: any) {
        if (!this.addAddressForm) {
            return;
        }
        const form = this.addAddressForm;

        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && !control.valid) {

                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                   this.formErrors[field] += messages[key] + ' ';
                }
            }
        }

    }

   ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
